<template>
  <component :is="tag" @click="cancelBet()">
    {{t('Betslip.CancelBet')}}
  </component>
</template>

<script>
  import CancelPlacedBetslipRequestService from '@/agent/services/betslip/cancel-placed-betslip-request-service.js';
  import { EventBus } from '@/services/event-bus-service';

  export default {
    name: 'CancelPlacedBetslipButtonComponent',
    data(){
      return{
        printPaidCanceled:APP_SETTINGS.print.autoPrintPaidCanceled,
      };
    },
    props: {
      detailsId: {
        type: Number
      },
      tag: {
        type: String,
        default: 'button',
      },
    },
    methods: {
      cancelBet() {
        // display confirmation modal
        EventBus.$emit('modalMessage', {
          showModal: true,
          messageType: 'info',
          messageText: this.$translate.text('VoidEvent.Message'),
          modalSize: 'md',
          modalPossition: 'start',
          buttons: [
            {
              label: this.$translate.text('Mobile.newoktext'),
              event: `confirmCancel_${this.detailsId}`,
            },
            {
              label: this.$translate.text('Public.Close'),
              event: `backCancel_${this.detailsId}`,
            }
          ],
        });
        this.attachEvents();
      },
      // attach event listeners for action buttons
      attachEvents() {
        EventBus.$on(`confirmCancel_${this.detailsId}`, () => {
          this.cancelPlacedBet();
          this.closeModal();
          this.detachEvents();
        });
        EventBus.$on(`backCancel_${this.detailsId}`, () => {
          this.closeModal();
          this.detachEvents();
        });
      },
      // remove event listeners after action is executed
      detachEvents() {
        EventBus.$off(`confirmCancel_${this.detailsId}`);
        EventBus.$off(`backCancel_${this.detailsId}`);
      },
      closeModal() {
        EventBus.$emit('modalMessage', {
          showModal: false,
        });
      },
      cancelPlacedBet() {
        const cancelPlacedBetslipService = new CancelPlacedBetslipRequestService();
        cancelPlacedBetslipService.postParams.BetSlipGroupID = this.detailsId;
        cancelPlacedBetslipService.execute((resp) => {
          this.$emit('showApiMsg', {
            betslipId: this.detailsId,
            type: resp.data.ResponseCode === 0 ? 'success' : 'error',
            text: resp.data.ResponseMessage || (resp.data.ResponseCode === 0 ? 'A.CancelSuccess' : 'BetSlip.CancelledFailed'),
          });
          if(this.printPaidCanceled && resp.data.ResponseCode === 0 ){
            return this.$emit("printCancel",);
          }else{
            return false;
          }
        }, (error) => {
          if (error.response.status === 401) {
            this.$emit('showApiMsg', {
              betslipId: this.detailsId,
              type: 'error',
              text: 'User.NoPermission',
            });
          }
        });
      },
    },
  };
</script>
